// extracted by mini-css-extract-plugin
export var cardLayout = "_a2-1";
export var paginationContainer = "_a2-0";